import React from "react";
import { ReactComponent as ListPinkIcon } from "../../../assets/icons/linkpink.svg";
import { ReactComponent as ListPinkIconMobile } from "../../../assets/icons/PolygonMobile.svg";
import { useSelector } from "react-redux";

import new_profile from "../../../assets/images/new_profile_rm.svg";
import new_profile_mobile from "../../../assets/images/New_profile_mobile.svg";

import {
  CREATE_VERTICAL_PROFILE,
  CREATE_PROFILE_VERTICAL_TITLE,
  CREATE_PROFILE_VERTICAL_BUTTON,
} from "../../../constants/constants";
import { Link, useNavigate } from "react-router-dom";

const BusinessProfileWidget = () => {
  const { isLoggedIn } = useSelector((state) => state.auth);

  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate("/login", {
      state: { redirectToStep: 6 },
    })
  }

  return (
    <>
      <div className="desktopBusinessProfile hidden sm:block lg:max-w-sm bg-white border border-gray-200 rounded-lg text-left mt-5 md:mt-0 w-full mb-4">
        <div className="w-full h-[140px] bg-footer rounded-t-[8px] flex justify-center items-center">
          <img className="rounded-t-lg" src={new_profile} alt="" />
        </div>
        <div className="p-5">
          <h5 className="mb-2 text-2xl font-bold tracking-tight text-black">
            {CREATE_PROFILE_VERTICAL_TITLE}
          </h5>
          <ul className="text-light font-sans text-f14 font-semibold">
            {CREATE_VERTICAL_PROFILE.map((text) => (
              <li key={text} className="flex item-center gap-3 py-1 text-f14">
                <ListPinkIcon /> {text}
              </li>
            ))}
          </ul>
          <button
            type="button"
            className="text-white right-3 bottom-2 bg-primary font-sans text-f14 rounded-3xl px-5 mt-2 py-3 font-semibold w-full"
          >
            {(isLoggedIn) ? (
              <Link className="text-white right-3 bottom-2 bg-primary font-sans text-f14 rounded-3xl px-5 mt-2 py-3 font-semibold w-full" to={"/sign-up"} state={{ redirectToStep: 6 }}>{CREATE_PROFILE_VERTICAL_BUTTON}</Link>
            ) : (
              <div className="text-white right-3 bottom-2 bg-primary font-sans text-f14 rounded-full px-5 font-semibold w-full" onClick={handleNavigate} >{CREATE_PROFILE_VERTICAL_BUTTON}</div>
            )}
          </button>
        </div>
      </div>

      <div className="mobileBusinessProfile sm:hidden lg:max-w-sm bg-company border border-gray-200 rounded-lg text-left mt-5 md:mt-0 w-full mb-4">
        <div className="p-5">
          <h5 className="mb-2 text-2xl font-bold tracking-tight text-white">
            {CREATE_PROFILE_VERTICAL_TITLE}
          </h5>
          <div className="flex justify-between items-center">
            <div>
              <ul className="text-light font-sans text-f14 font-semibold">
                {CREATE_VERTICAL_PROFILE.map((text) => (
                  <li key={text} className="flex text-white item-center gap-3 py-1 text-f14">
                    <ListPinkIconMobile /> {text}
                  </li>
                ))}
              </ul>
              <button
                type="button"
                className="text-companyText right-3 bottom-2 bg-white  font-sans text-f14 rounded-3xl px-5 mt-2 py-3 font-semibold w-full "
              >
                {CREATE_PROFILE_VERTICAL_BUTTON}
              </button>
            </div>
            <div><Link to="#">
              <img className="rounded-t-lg w-full" src={new_profile_mobile} alt="" />
            </Link></div>
          </div>
        </div>
      </div>

    </>
  );
};

export default BusinessProfileWidget;
